// extracted by mini-css-extract-plugin
export default {"companyDataContainer":"about_companyDataContainer__arpXm","companyItem":"about_companyItem__cDCdn"};